import { ZiroIcons } from '../shared/models/ziro-icons.enum';
import { NavSection } from '../shared/side-navigation/side-navigation.model';

export const zpmAdminLinks: NavSection[] = [
  {
    icon: ZiroIcons.NONE,
    title: 'tkey;admin.microsoft.global_settings.title',
    isText: true,
  },
  {
    icon: ZiroIcons.HEALTH,
    dataAutomation: 'system-health-section-header-link',
    title: 'tkey;system_status.title',
    isLink: true,
    link: '/admin/system-health-status',
  },
  {
    icon: ZiroIcons.SLIDERS,
    title: 'tkey;admin.menu.section.system',
    dataAutomation: 'system-section-header',
    links: [
      {
        link: '/admin/system/microsoft-general-settings',
        text: 'tkey;admin.microsoft.general_settings.title',
        dataAutomation: 'menu-microsoft-general-settings-link',
        isDisabled: (flags) => flags.isLicenseExpired,
        disabledTooltip: (flags) => {
          return flags.isLicenseExpired ? 'tkey;admin.menu.license_expired.tooltip' : null;
        },
      },
      {
        link: '/admin/system/customize-login-page',
        text: 'tkey;admin.ui.title',
        dataAutomation: 'menu-ui-link',
        isDisabled: (flags) => flags.isLicenseExpired,
        disabledTooltip: (flags) => {
          return flags.isLicenseExpired ? 'tkey;admin.menu.license_expired.tooltip' : null;
        },
      },
    ],
  },
  {
    icon: ZiroIcons.SHIELD,
    dataAutomation: 'security-and-permissions',
    title: 'tkey;admin.menu.section.security_and_permissions',
    links: [
      {
        link: '/admin/security-and-permissions/saml-sso',
        text: 'tkey;admin.saml.title',
        dataAutomation: 'menu-saml-link',
        isDisabled: (flags) => flags.isLicenseExpired,
        disabledTooltip: (flags) => {
          return flags.isLicenseExpired ? 'tkey;admin.menu.license_expired.tooltip' : null;
        },
      },
      {
        link: '/admin/security-and-permissions/user-permissions',
        text: 'tkey;admin.system.user_permissions.title',
        dataAutomation: 'menu-user-permissions-link',
      },
      {
        link: '/admin/security-and-permissions/oauth2-resource-server-management',
        text: 'tkey;admin.system.oauth2_resource_server_management.title',
        dataAutomation: 'menu-oauth2-resource-server-management-link',
        isDisabled: (flags) => flags.isLicenseExpired,
        disabledTooltip: (flags) => {
          return flags.isLicenseExpired ? 'tkey;admin.menu.license_expired.tooltip' : null;
        },
        isVisible: (flags) => {
          return flags.isAutomationModuleEnabled;
        },
      },
    ],
  },
  {
    icon: ZiroIcons.SERVER,
    title: 'tkey;admin.proxy_server_management.title',
    dataAutomation: 'proxy-server-management-section-header',
    links: [
      {
        link: '/admin/proxy-server-management/generate-key',
        text: 'tkey;admin.proxy_server_management.generate_key.title',
        dataAutomation: 'menu-proxy-server-generate-key-link',
      },
      {
        link: '/admin/proxy-server-management/proxy-feature-settings',
        text: 'tkey;admin.proxy_server_management.proxy_feature_settings.title',
        dataAutomation: 'menu-proxy-feature-settings-link',
        isDisabled: (flags) => !flags.isZpmProxyKeyConfigured,
        disabledTooltip: (flags) => {
          return flags.isZpmProxyKeyConfigured ? '' : 'tkey;admin.menu.proxy_key_unconfigured.tooltip.zpm';
        },
      },
    ],
  },
  {
    icon: ZiroIcons.AUDITS,
    title: 'tkey;admin.menu.section.audits',
    dataAutomation: 'audits-section-header',
    links: [
      {
        link: '/admin/audits/logs',
        text: 'tkey;admin.audits.logs.title',
        dataAutomation: 'menu-audit-logs-link',
        isDisabled: (flags) => flags.isLicenseExpired,
        disabledTooltip: (flags) => {
          return flags.isLicenseExpired ? 'tkey;admin.menu.license_expired.tooltip' : null;
        },
      },
      {
        link: '/admin/audits/settings',
        text: 'tkey;admin.audits.settings.title',
        dataAutomation: 'menu-audit-settings-link',
        isDisabled: (flags) => flags.isLicenseExpired,
        disabledTooltip: (flags) => {
          return flags.isLicenseExpired ? 'tkey;admin.menu.license_expired.tooltip' : null;
        },
      },
    ],
  },
  {
    icon: ZiroIcons.HASH,
    title: 'tkey;admin.order_numbers.title',
    dataAutomation: 'order-numbers-section-header',
    isVisible: (flags) => {
      return flags.portingEnabled;
    },
    links: [
      {
        link: '/admin/order-numbers/port-in-orders',
        text: 'tkey;admin.order_numbers.port_in_orders.title',
        dataAutomation: 'menu-port-in-orders-link',
        isDisabled: (flags) => flags.isLicenseExpired,
        disabledTooltip: (flags) => {
          return flags.isLicenseExpired ? 'tkey;admin.menu.license_expired.tooltip' : null;
        },
      },
      {
        link: '/admin/order-numbers/port-in-number-status',
        text: 'tkey;admin.order_numbers.port_in_number_status.title',
        dataAutomation: 'menu-port-in-number-status-link',
        isDisabled: (flags) => flags.isLicenseExpired,
        disabledTooltip: (flags) => {
          return flags.isLicenseExpired ? 'tkey;admin.menu.license_expired.tooltip' : null;
        },
      },
    ],
  },
  {
    icon: ZiroIcons.NONE,
    title: 'tkey;admin.menu.tenants.title',
    isText: true,
  },
  {
    icon: ZiroIcons.ADD,
    dataAutomation: 'menu-tenant-management-add-link',
    title: 'tkey;admin.tenant_management.add.config.title',
    isLink: true,
    link: '/admin/tenants/new',
    isDisabled: (flags) => flags.isLicenseExpired,
    disabledTooltip: (flags) => {
      return flags.isLicenseExpired ? 'tkey;admin.menu.license_expired.tooltip' : null;
    },
  },
];
